import type { UserType } from "@shared/types";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/ui/status-badge";
import { ViewingAsBanner } from "@/features/roles/components/viewing-as-banner";

/**
 * A project the user is on through a role that is not the active one. Only
 * the title, the status and a switch to that role are shown; the project's
 * tabs and actions belong to the other role's view of it.
 */
export function ProjectViewingAs({
	title,
	status,
	viewerRole,
	backLabel,
	onBack,
}: {
	title: string;
	status: string;
	viewerRole: UserType;
	/** Defaults to "Back to Projects". */
	backLabel?: string;
	onBack: () => void;
}): React.JSX.Element {
	const { t } = useTranslation();
	return (
		<div className="min-h-screen bg-dashboard-bg py-8">
			<div className="mx-auto max-w-4xl px-4">
				<Button
					variant="ghost"
					size="sm"
					onClick={onBack}
					className="mb-6 text-dashboard-muted"
				>
					<ArrowLeft className="h-4 w-4" />
					{backLabel ?? t("common.backToProjects")}
				</Button>
				<h1 className="font-display text-2xl font-medium tracking-tight text-dashboard-text">
					{title}
				</h1>
				<div className="mt-2">
					<StatusBadge status={status} />
				</div>
				<ViewingAsBanner role={viewerRole} className="mt-6" />
			</div>
		</div>
	);
}
